module.exports = __webpack_public_path__ + "static/img/h21.a5f3a44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h21.jpg
// module id = Rwim
// module chunks = 0